import { Box, Card as MuiCard, CardContent as MuiCardContent, Typography, Divider as MuiDivider, withStyles, Button } from "@material-ui/core"
import styled from "styled-components/macro";
import { spacing } from "@material-ui/system";
import { AccessibilityUnit } from "../models/AccessibilityUnits";
import { useTranslation } from "react-i18next";

const Divider = styled(MuiDivider)(spacing);
const Card = styled(MuiCard)(spacing);
const CardContent = styled(MuiCardContent)`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom:0px;
`
const InfoIcon = styled.img`
    height: 56px;
    width: 56px;
`
const StyledButton = withStyles({
    root: {
        border: '1px solid black',
        color: 'black',
        backgroundImage: 'linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);'
    },
})(Button);

export const ImageUploader = ({
    existingUnit,
    handleOpenDialog
}: {
    handleOpenDialog: () => void;
    existingUnit: AccessibilityUnit | null
}) => {
    const { t } = useTranslation();
    return (
        <>
            <Card mb={4}>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        {t("questionUnits_resources")}
                    </Typography>
                    <Divider my={4} />
                    <Box display="flex" justifyContent="center">
                        <InfoIcon src="/static/img/icons/uploadIcon.svg" />
                    </Box>
                    <Box mt={3}>
                        <Typography variant="h6" gutterBottom>
                            {t("questionUnits_uploadPictures")}
                        </Typography>
                    </Box>
                    {/*<Box>*/}
                    {/*    <Typography variant="body2" gutterBottom style={{ color: 'rgba(238, 238, 238, 0.5)' }}>*/}
                    {/*        {t("questionUnits_explanation")}*/}
                    {/*    </Typography>*/}
                    {/*</Box>*/}
                    <Box mt={3}>
                        <StyledButton
                            onClick={handleOpenDialog}
                            fullWidth
                            disabled={existingUnit ? false : true}
                            style={{
                                color: !existingUnit ? '#929292' : 'black',
                                border: !existingUnit ? '1px solid #929292' : '1px solid black'
                            }}>
                            {t("questionUnits_uploadLabel")}
                        </StyledButton>
                    </Box>
                </CardContent>
            </Card>

        </>
    )
}
